module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-skip.png?v=cd4eb2b6";